import type { UnmanagedMutationErrorHandler, UnmanagedQueryErrorHandler } from "@modules/shell/client";
import type { QueryClientConfig } from "@tanstack/react-query";
import { MutationCache, QueryCache } from "@tanstack/react-query";

export interface CreateQueryClientConfigOptions {
    onQueryError?: UnmanagedQueryErrorHandler;
    onMutationError?: UnmanagedMutationErrorHandler;
}

export function createQueryClientConfig(options: CreateQueryClientConfigOptions = {}) {
    const { onQueryError, onMutationError } = options;

    return {
        defaultOptions: {
            queries: {
                staleTime: 1000 * 60 * 5,
                refetchOnWindowFocus: false
            }
        },
        queryCache: onQueryError
            ? new QueryCache({
                  onError: error => onQueryError(error)
              })
            : undefined,
        mutationCache: onMutationError
            ? new MutationCache({
                  onError: (error, _variables, _onMutateResult, mutation) => {
                      if (!mutation.meta?.skipGlobalErrorHandler) {
                          onMutationError(error);
                      }
                  }
              })
            : undefined
    } satisfies QueryClientConfig;
}
